export default __webpack_public_path__ + "static/b1e92c74d92f8cfa73906c101bcc2079.ttf";